export default __webpack_public_path__ + "7f6af5b9451f6cde28c4145588eea12a.svg";